<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'error'">
    <div class="alert alert-danger" role="alert" [innerHTML]="text"></div>
  </ng-container>
  <ng-container *ngSwitchCase="'success'">
    <div class="alert alert-success" role="alert" [innerHTML]="text"></div>
  </ng-container>
</ng-container>

